import React, { useState, useEffect } from 'react';
import { ItemDepartmentName, ItemDepartmenListSelect } from '../../item/DepartmentItems';
import { ItemRoleName, ItemRoleListSelect, ItemRoleIsSupervisor, ItemRoleIsDisable } from '../../item/RoleItems';

export function RoleContent({departmentId, role, sn, ss, sm, sd, change}){
  const[mRole, setRole] = useState({})
  const [roleName, setRoleName] = useState("")
  const [isSupervisor, setIsSupervisor] = useState(false)
  const [managerRoleId, setManagerRoleId] = useState("")
  const [isDisable, setIsDisable] = useState(false)
  const [mChange, setChange] = useState(false)
    
  useEffect(()=>{
    if(role !== undefined && role !== mRole){
      console.log(role)
      setRoleName(role.roleName)
      setIsSupervisor(role.isSupervisor)
      setManagerRoleId(role.managerRoleId)
      setIsDisable(role.isDisable)
      //setChange(!mChange)
    }
  },[role])
  

    function setName(val){
      setRoleName(val)
        if(sn!==undefined)
        sn(val)
    }
    function setSupervisor(val){
      setIsSupervisor(val)
        if(ss!==undefined)
            ss(val)
    }

    function setRoleId(val){
      setManagerRoleId(val)
        if(sm!==undefined)
            sm(val)
    }
    function setDisable(val){
      setIsDisable(val)
        if(sd!==undefined)
            sd(val)
    }


    return(
      <>
      <div className="row">
        <div className="col-sm-6">
          <ItemRoleName roleName={roleName} setRoleName={setName} />
        </div>
        <div className="col-sm-6">
          <ItemRoleListSelect departmentId={departmentId} managerRoleId={managerRoleId} setManagerRoleId={setRoleId} change={mChange} />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <ItemRoleIsSupervisor isSupervisor={isSupervisor} setIsSupervisor={setSupervisor} />
        </div>
        <div className="col-sm-6">
          <ItemRoleIsDisable isDisable={isDisable} setisDisable={setDisable} />
        </div>
      </div>
      </>
    )
  }